import { render, staticRenderFns } from "./QuoteGeneralInfo.vue?vue&type=template&id=628c5378&scoped=true&"
import script from "./QuoteGeneralInfo.vue?vue&type=script&lang=js&"
export * from "./QuoteGeneralInfo.vue?vue&type=script&lang=js&"
import style0 from "./QuoteGeneralInfo.vue?vue&type=style&index=0&id=628c5378&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628c5378",
  null
  
)

export default component.exports